// extracted by mini-css-extract-plugin
export default {"concept":"styles_concept__SYUz0","title":"styles_title__YgxfX","list":"styles_list__JG04e","item":"styles_item__Lmks4"};